import React from "react";
import { useNavigate } from "react-router-dom";
import ChoshiiLogo from "../ChoshiiLogo";

const PostUploadAd: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#0b0f1a",
        color: "#fff",
        padding: 24,
        textAlign: "center",
      }}
    >
      <ChoshiiLogo style={{ width: 160, marginBottom: 32 }} />

      <h1 style={{ fontSize: 28, marginBottom: 12 }}>
        ✅ Thanks for advertising with us
      </h1>

      <p style={{ fontSize: 16, opacity: 0.85, maxWidth: 520 }}>
        Your advertisement has been submitted successfully.
      </p>

      <p style={{ fontSize: 14, opacity: 0.7, marginTop: 12 }}>
        Our team is currently reviewing it. Once approved, it will be published
        and visible in the gallery.
      </p>

      <button
        onClick={() => navigate("/advertisementstart")}
        style={{
          marginTop: 32,
          padding: "12px 22px",
          borderRadius: 10,
          background: "#4f46e5",
          color: "#fff",
          fontWeight: 600,
          border: "none",
          cursor: "pointer",
        }}
      >
        Back to Advertisement
      </button>
    </div>
  );
};

export default PostUploadAd;
